import React from 'react';
import { HomeOptionContainerProps } from './homeOptionProps';
import { ReportingContainerBaseConfig } from '../../../base';
import { HomeOptionController } from './homeOptionInterface';
import { HomeOptionFormValues } from './homeOptionModel';
import { useForm } from 'react-hook-form';

export function createHomeOptionContainer(
    config: ReportingContainerBaseConfig,
    controller: HomeOptionController
): React.FC<HomeOptionContainerProps> {
    const {
        context: { useContext },
        state: states,
    } = config;
    return states.composer.subscribe(({ as: View, ...containerProps }) => {
        const context = useContext();
        const state = states.composer.useState(context);
        const form = useForm<HomeOptionFormValues>({
            defaultValues: {
                test: state.value.test,
                version: state.value.version,
            },
        });
        const props = controller.useProps(context, {
            form: {
                id: 'home-option',
                form: form,
                onSubmit(values) {
                    console.log('home option form', values);
                    state.onChange({
                        test: values.test,
                        version: values.version,
                    });
                    containerProps.onSubmit?.(values);
                },
            },
            values: form.watch(),
        });
        return <View {...props} />;
    });
}
